import React from 'react';

const RefreshSVG = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='currentColor'
      {...props}
    >
      <path
        d='M1 1.5V7.5M1 7.5H7M1 7.5C3.32744 5.41141 5.48287 3.04676 8.7453 2.58779C10.6777 2.31593 12.6461 2.67941 14.3539 3.62343C16.0617 4.56746 17.4164 6.04091 18.2139 7.82177M19 19.5V13.5M19 13.5H13M19 13.5C16.6725 15.5886 14.5171 17.9532 11.2546 18.4122C9.3223 18.6841 7.35388 18.3206 5.64607 17.3766C3.93826 16.4325 2.58353 14.9591 1.78601 13.1782'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};

export default RefreshSVG;
